import { useState, useRef } from "react";
import { API_URL, getValFromLS, isFieldError } from "../../helpers";

import Select from "../../components/Select";
import Input from "../../components/Input";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

const Form = ({ registrationId, success }) => {
  const [errors, setErrors] = useState([]);
  const [names, setNames] = useState({});
  const [msg, setMsg] = useState({});

  const formElement = useRef();

  const handleUpdate = (name, value) => {
    if (name === "asset" && value) {
      setNames((names) => ({
        ...names,
        [name]: value,
        qty: "1",
        amount: value === "donation" ? "" : "500",
      }));
    } else if (name === "asset") {
      setNames((names) => ({ ...names, [name]: value, amount: "0" }));
    } else {
      setNames((names) => ({ ...names, [name]: value ? value : "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/admin/addonsAdd`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      data.append(key, value);
    });
    data.append("registrationId", registrationId);
    data.append("token", getValFromLS("vtoUserToken"));

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setMsg({});
        formElement.current.reset();
        setNames({});
        success();
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <form
      ref={formElement}
      method="post"
      action="/"
      onSubmit={(e) => handleSubmit(e)}
      className="well"
      style={{ marginTop: "25px" }}
    >
      <div className="form-group">
        <Select
          name="asset"
          label="Asset Type"
          reqd={true}
          value={""}
          options={[
            { id: "", name: "--", val: "" },
            {
              id: "welcome",
              name: "Welcome Party",
              val: "500",
            },
            {
              id: "tentThu",
              name: "Valero Tent Thursday",
              val: "500",
            },
            {
              id: "tentFri",
              name: "Valero Tent Friday",
              val: "500",
            },
            {
              id: "tentSat",
              name: "Valero Tent Saturday",
              val: "500",
            },
            {
              id: "tentSun",
              name: "Valero Tent Sunday",
              val: "500",
            },
            {
              id: "donation",
              name: "Donation",
              val: "0",
            },
          ]}
          update={handleUpdate}
          error={isFieldError(errors, "asset")}
        />

        <div className="empty" />
      </div>

      {names.asset && (
        <div className="form-group">
          <Input
            name="qty"
            label="Quantity"
            value={names.qty || ""}
            autocomplete="off"
            update={handleUpdate}
            errors={errors}
          />

          <Input
            name="amount"
            label="Amount (ea.)"
            reqd={true}
            value={names.amount || "0"}
            autocomplete="off"
            update={handleUpdate}
            errors={errors}
          />
        </div>
      )}

      <div className="msg-submit" style={{ marginTop: "30px" }}>
        {msg.type && <Msg data={msg} />}

        <div
          className={
            msg.type === "working" ||
            msg.type === "notice" ||
            msg.type === "success"
              ? "hidden"
              : "submit-container"
          }
        >
          <Submit submit="Add Asset to Registration" />
        </div>
      </div>
    </form>
  );
};

export default Form;
